import React from "react"

import Text from "@components/ui/Typography/Text"
import {
  CategoryInfo,
  QueryFilterCategory,
} from "@framework/types/query-filter"
import Button from "@components/ui/Button/Button"
import Icon from "@components/ui/Icon/Icon"
import { camelCaseToWords, capitalizeFirstLetter } from "@utils/textUtils"
import IconButton from "@components/ui/IconButton/IconButton"

import styles from "./ProductsSection.module.sass"

export interface FilterButtonProps {
  category: string
  count?: number
  name: string
  queryFilterCategory?: QueryFilterCategory
  setSelectedCategory: React.Dispatch<
    React.SetStateAction<CategoryInfo | undefined>
  >
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  category,
  count,
  name,
  queryFilterCategory,
  setSelectedCategory,
}) => {
  let heading = name
  let isData = false
  if (category === "data") {
    heading = name.replace(/^data/, "content")
    isData = true
  }
  return (
    <Button
      after={
        <IconButton>
          <Icon name="line-arrow-down" rotateAngle={-90} />
        </IconButton>
      }
      variant="text"
      size="small"
      onClick={() =>
        setSelectedCategory({
          parentCategory: category,
          name,
          queryFilterCategory,
          mainCategory: category,
          ...(isData ? { subcategoryId: name } : {}),
        })
      }
      className={styles.category}
    >
      <Text variant="body2" className={styles.name}>
        {capitalizeFirstLetter(camelCaseToWords(heading))}&nbsp;
        <Text variant="body2" className={styles.count}>
          ({count})
        </Text>
      </Text>
    </Button>
  )
}
